import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import * as Common from 'common/components';
import Validated from 'components/util/Validated';

const { Form } = Common;

const ExchangeForm = ({
  company,
  coins,
  errors,
  handleAddCustomField,
  handleRemoveCustomField,
  handleSubmit,
  handleValueChange,
  isSaving,
  isSubmitted,
  t,
  values,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <div className="col-md-12 mt-3">
        <div className="row">
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldDate
              error={(isSubmitted && errors.date) || {}}
              isLoading={isSaving}
              name={'date'}
              label={t('exchange.fields.date')}
              handleChange={handleValueChange}
              t={t}
              value={values.date}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldSelect
              error={(isSubmitted && errors._fromCurrency) || {}}
              isLoading={isSaving}
              name={'_fromCurrency'}
              label={t('exchange.fields.fromCurrency')}
              handleChange={handleValueChange}
              t={t}
              value={values._fromCurrency}
            >
              {coins.map((c) => (
                <option key={c.key} value={c.key}>
                  {t(c.key)} - {t(c.value)}
                </option>
              ))}
            </Form.FieldSelect>
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldSelect
              error={(isSubmitted && errors._toCurrency) || {}}
              isLoading={isSaving}
              name={'_toCurrency'}
              label={t('exchange.fields.toCurrency')}
              handleChange={handleValueChange}
              t={t}
              value={values._toCurrency}
            >
              {coins.map((c) => (
                <option key={c.key} value={c.key}>
                  {t(c.key)} - {t(c.value)}
                </option>
              ))}
            </Form.FieldSelect>
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              className="text-right"
              error={(isSubmitted && errors.value) || {}}
              handleChange={(e) => {
                let { name, value } = e.target;
                value = parseFloat(value);
                value = Number.isNaN(value) ? '' : value;
                handleValueChange({ target: { value, name } });
              }}
              isLoading={isSaving}
              label={t('exchange.fields.value')}
              name={'value'}
              t={t}
              type="number"
              value={values.value}
            />
          </div>
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={`/companies/${company.id}/exchange`}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    _fromCurrency: { type: 'string', minLength: 1 },
    _toCurrency: { type: 'string', minLength: 1 },
    date: { type: 'string', format: 'date-time', minLength: 1 },
    value: { type: 'number' },
  },
  required: ['date', '_fromCurrency', '_toCurrency', 'value'],
})(translate()(ExchangeForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/form/ExchangeForm.js